import ct from 'countries-and-timezones';

function getAllCountriesTimezones() {
  const countries = ct.getAllCountries();
  const select = [];

  Object.keys(countries).forEach((key) => {
    const country = countries[key].name;
    select.push({ header: country });
    countries[key].timezones.map((timezone) => {
      select.push({ timezone: `${timezone} - ${country}`, group: country });
    });
    select.push({ divider: true });
  });
  select.pop();
  return select;
}

function getTimezoneFormattedWithCountry(timezone) {
  const timezoneInfo = ct.getCountryForTimezone(timezone);
  return `${timezone} - ${timezoneInfo.name}`;
}

export { getAllCountriesTimezones, getTimezoneFormattedWithCountry };
